import { StationModel } from '../../dictStore/dictStoreData';
import AbstractNsiStoreService from '../abstractNsiStore.service';

export class NsiStationStoreService extends AbstractNsiStoreService<StationModel> {
  path = 'station';
}
